<template>
  <el-cascader class="area" ref="myArea" v-model="region" @change="handleChange" :props="area"></el-cascader>
</template>
<script>
import User from "@/api/user";
export default {
  props: {
    value: String,
    // partyOrginId: {
    //   default() {
    //     return []
    //   }
    // }
    index: {
      type: Number,
      default: 2,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ids: [],
      area: {
        lazy: true,
        index: this.index,
        list: [],
        lazyLoad: (node, resolve) => {
          setTimeout(() => {
            if (node.level == 0) {
              if (this.index != 2) {
                User.getProvinceVillage({}).then((res) => {
                  let data = res.data.map((item) => {
                    return {
                      value: item,
                      label: item,
                      disabled: this.disabled,
                    };
                  });
                  resolve(data);
                });
              } else {
                User.getProvince({}).then((res) => {
                  let data = res.data.map((item) => {
                    return {
                      value: item.provinceName,
                      label: item.provinceName,
                      code: item.provinceCode,
                      disabled: this.disabled,
                    };
                  });
                  resolve(data);
                });
              }
            }
            if (node.level == 1) {
              if (this.index != 2) {
                let params = {
                  province: node.pathNodes[0].value,
                };
                User.getCityVillage(params).then((res) => {
                  let data = res.data.map((item) => {
                    return {
                      value: item,
                      label: item,
                      disabled: this.disabled,
                    };
                  });
                  resolve(data);
                });
                return;
              } else {
                User.getCity({ provinceCode: node.data.code }).then((res) => {
                  let data = res.data.map((item) => {
                    return {
                      value: item.cityName,
                      label: item.cityName,
                      code: item.cityCode,
                      disabled: this.disabled,
                    };
                  });
                  resolve(data);
                });
              }
            }
            if (node.level == 2) {
              if (this.index != 2) {
                let params = {
                  province: node.pathNodes[0].value,
                  city: node.pathNodes[1].value,
                };
                User.getAreaVillage(params).then((res) => {
                  let data = res.data.map((item) => {
                    return {
                      value: item,
                      label: item,
                      disabled: this.disabled,
                    };
                  });
                  resolve(data);
                });
                return;
              }
              User.getArea({ cityCode: node.data.code })
                .then((res) => {
                  let data = res.data.map((item) => {
                    return {
                      value: item.areaName,
                      label: item.areaName,
                      code: item.areaCode,
                      leaf: node.level >= this.index,
                      disabled: this.disabled,
                    };
                  });
                  resolve(data);
                }).catch((err) => console.log(err));
            }
            if (node.level == 3) {
              if (this.index != 2) {
                let params = {
                  province: node.pathNodes[0].value,
                  city: node.pathNodes[1].value,
                  county: node.pathNodes[2].value,
                };
                User.getStreetVillage(params).then((res) => {
                  let data = res.data.map((item) => {
                    return {
                      value: item,
                      label: item,
                      disabled: this.disabled,
                    };
                  });
                  resolve(data);
                });
                return;
              }
              User.getStreet({ areaCode: node.data.code })
                .then((res) => {
                  let data = res.data.map((item) => {
                    return {
                      value: item.streetName,
                      label: item.streetName,
                      code: item.streetCode,
                      leaf: node.level >= this.index,
                      disabled: this.disabled,
                    };
                  });
                  resolve(data);
                })
                .catch((err) => console.log(err));
            }
            if (node.level == 4) {
              let data = {
                province: node.pathNodes[0].value,
                city: node.pathNodes[1].value,
                county: node.pathNodes[2].value,
                township: node.pathNodes[3].value,
              };
              User.getVillage(data)
                .then((res) => {
                  this.list = res.data;
                  let data = res.data.map((item) => {
                    return {
                      value: `${item.villageName}`,
                      label: item.villageName,
                      leaf: node.level >= this.index,
                      disabled: this.disabled,
                    };
                  });
                  resolve(data);
                })
                .catch((err) => console.log(err));
            }
          }, 100);
        },
      },
      region: null,
      list: [],
      id: "", // 村组id
    };
  },
  mounted() {
    this.region = this.value.split("/");
  },
  methods: {
    handleChange(value) {
      if (this.index == 4) {
        this.list.map((item) => {
          if (item.villageName == value[4]) {
            this.id = item.villageId;
            this.$emit("getAreaId", item.villageId);
          }
        });
      }
      let area = value.join("/");
      this.$emit("input", area);
    },
  },
};
</script>
<style lang="scss">
.el-cascader__dropdown {
  .el-cascader-node.is-disabled.in-active-path,
  .el-cascader-node.is-disabled.is-active {
    color: #f65248 !important;
  }
}
</style>